<template>
  <div v-if="currentRoles.name === '标签管理'" class="page-index label-manage">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['标签管理-新增']" class="btn-left" size="mini" @click="openModel(null)">添加标签</el-button>
      <div style="flex:1"></div>
      <el-select v-if="userInfo.companyList.length > 0" class="search-input" multiple collapse-tags v-model="query.companyIds" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select class="search-input" v-model="status" @change="seach">
        <el-option label="使用中" value="0"></el-option>
        <el-option label="已禁用" value="1"></el-option>
      </el-select>
      <el-input  class="search-input" size="mini" v-model="query.query" @keyup.enter.native="seach" placeholder="请输入关键字" />
    </div>
    <el-table
        ref="table"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="number"
          label="标签编号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="name"
          label="标签名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="product.code"
          label="商品编号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="product.name"
          label="商品名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="address"
          label="产地">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="180"
          label="操作">
        <template slot-scope="scope">
          <div v-if="currentRoles.roles['标签管理-禁用']" style="display:inline-block;margin-right:10px;">
            <el-tooltip v-if="scope.row.status === 0" content="禁用" placement="top">
              <el-button size="mini" @click.stop="handleSwitch(scope.row)" title="禁用">
                <i class="icon el-icon-disable"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="scope.row.status === 1" content="启用" placement="top">
              <el-button size="mini" @click.stop="handleSwitch(scope.row)">
                <i class="icon el-icon-enable"></i>
              </el-button>
            </el-tooltip>
          </div>
          <el-tooltip v-if="currentRoles.roles['标签管理-编辑']" content="编辑" placement="top">
            <el-button size="mini" @click.stop="openModel(scope.row)">
              <i class="icon el-icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="currentRoles.roles['标签管理-删除']" content="删除" placement="top">
            <el-button size="mini" @click.stop="handleDelete(scope.row)">
              <i class="icon el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加标签"
        :visible.sync="dialogVisible"
        width="550px"
        :before-close="handleClose">
      <el-form ref="labelForm" :model="form" label-width="180px">
        <el-form-item label="标签名称">
          <el-input placeholder="请输入标签名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="选择公司" prop="parentId">
          <el-select class="search-input" v-model="companyId" @change="seach2" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择商品" prop="parentId">
          <el-select
              class="search-input"
              filterable
              remote
              :remote-method="getProductList"
              v-model="form.productId"
              @change="seach"
              placeholder="请选择商品">
            <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择复用的标签模板" prop="parentId">
          <el-select class="search-input" v-model="form.copyLabelCode" placeholder="请选择复用的标签模板">
            <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.number"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地">
          <el-input placeholder="请输入产地" v-model="form.address"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改标签"
        :visible.sync="dialogVisible2"
        width="550px"
        :before-close="handleClose">
      <el-form ref="labelForm2" :model="form" label-width="180px">
        <el-form-item label="标签名称">
          <el-input placeholder="请输入标签名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="选择商品" prop="parentId">
          <el-select
              class="search-input"
              filterable
              remote
              :remote-method="getProductList"
              v-model="form.productId"
              @change="seach"
              placeholder="请选择商品">
            <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地">
          <el-input placeholder="请输入产地" v-model="form.address"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">保 存</el-button>
        <el-button type="primary" @click="openPage">模板修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiLabelEdit, apiDelete, apiSwitch, apiDetail, apiLabelList, apiCopyLabel } from '../../api/label'
  import { apiList } from '../../api/product'

  export default {
    mixins: [tableMixin],
    name: 'userInfo',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        list: [],
        list2: [],
        productList: [],
        status: '0',
        pageIndex: 1,
        total: 0,
        companyId: null,
        id: '',
        currentRow: {},
        query: {
          query: '',
          companyIds: []
        },
        form: {
          name: '',
          companyId: '',
          productId: '',
          copyLabelCode: '',
          address: ''
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      if (this.userInfo.companyList) {
        this.query.companyIds.push(this.userInfo.companyList[0].id)
        this._getList()
      }
    },
    activated() {},
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 打开model
      openModel(row) {
        if (row) {
          this.dialogVisible2 = true
          this.productList.push(row.product)
          this.form.name = row.name
          this.form.productId = row.product.id
          this.form.address = row.address
          this.id = row.id
          this.currentRow = row
        } else {
          this.dialogVisible = true
          this.form = {
            name: '',
            companyId: '',
            productId: '',
            copyLabelCode: '',
            address: ''
          }
        }
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
        }).catch(_ => {})
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      seach2() {
        this._getList2()
      },
      openPage() {
        window.open('http://dev.anschina.cn:8080/mr/mireport/designer/r.jsp?report=' + this.currentRow.number + '&ds=tagbzd1')
      },
      // 获取商品列表
      getProductList(value) {
        apiList(this.companyId, value, '', 1, 10).then(data => {
          this.productList = data.data.data
        })
      },
      // 获取列表
      _getList(pageIndex = 1) {
        if (this.query.companyIds.length === 0) return
        apiLabelList(1, this.status, this.query, pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 获取列表
      _getList2(pageIndex = 1) {
        apiLabelList(1, 0, { companyIds: [this.companyId] }, pageIndex, 9999).then(data => {
          this.list2 = data.data.data
        })
      },
      // 新增
      handleAdd() {
        let label = {
          name: this.form.name,
          companyId: this.companyId,
          productId: this.form.productId,
          address: this.form.address
        }
        apiLabelEdit(label).then(data => {
          this.$message({
            type: 'success',
            message: '新增成功'
          })
          console.log(this.form.copyLabelCode)
          if (this.form.copyLabelCode) { // 复用
            apiCopyLabel(this.form.copyLabelCode, data.data.number)
          }
          this.dialogVisible = false
          this._getList()
        })
      },
      // 编辑
      handleEdit() {
        let label = {
          id: this.id,
          name: this.form.name,
          productId: this.form.productId,
          address: this.form.address
        }
        apiLabelEdit(label).then(() => {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.dialogVisible2 = false
          this._getList()
        })
      },
      // 禁用/启用
      handleSwitch(row) {
        this.$confirm(`是否${row.status === 0 ? '停用' : '启用'}标签：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiSwitch(row.id).then(() => {
            this.$message({
              type: 'success',
              message: `${row.status === 0 ? '停用' : '启用'}成功`
            })
            this._getList()
          })
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除标签：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id, 2).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.label-manage
    .el-form-item__content
      width 200px
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
</style>
